import { render, staticRenderFns } from "./social-links.component.vue?vue&type=template&id=c7b13d98"
import script from "./social-links.component.vue?vue&type=script&lang=js"
export * from "./social-links.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports